interface CardItem {
  image: string;
  title: string;
  tag: string;
  desc: string;
  meta: string;
}

const cards: CardItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20of%20a%20magical%20girl%20in%20a%20cherry%20blossom%20garden%2C%20soft%20pink%20and%20white%20color%20scheme%2C%20dreamy%20atmosphere%2C%20clean%20background%20with%20falling%20petals%2C%20Japanese%20animation%20art%20style%2C%20high%20quality%20digital%20illustration%2C%20warm%20lighting%2C%20beautiful%20composition&width=800&height=600&seq=91sakura-card-01&orientation=landscape',
    title: '七月新番全面上线',
    tag: '新番速递',
    desc: '本季热门新番已全部收录，涵盖热血、治愈、悬疑等多种题材，让你追番不迷路。',
    meta: '已更新 42 部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20futuristic%20cityscape%20at%20sunset%20with%20cherry%20blossom%20trees%20lining%20the%20streets%2C%20warm%20orange%20and%20pink%20sky%2C%20clean%20modern%20anime%20art%2C%20soft%20atmospheric%20lighting%2C%20beautiful%20composition%2C%20digital%20painting%20style%2C%20high%20detail&width=800&height=600&seq=91sakura-card-02&orientation=landscape',
    title: '经典神作回顾专区',
    tag: '经典重温',
    desc: '精选历年豆瓣高分动漫佳作，从EVA到钢炼，每一部都是不可错过的传世经典。',
    meta: '收录 200+ 部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20illustration%20of%20a%20cozy%20Japanese%20tea%20house%20surrounded%20by%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20natural%20lighting%2C%20warm%20pastel%20colors%2C%20peaceful%20atmosphere%2C%20detailed%20background%2C%20studio%20ghibli%20inspired%20aesthetic%2C%20high%20quality%20digital%20art&width=800&height=600&seq=91sakura-card-03&orientation=landscape',
    title: '剧场版动画合集',
    tag: '剧场精选',
    desc: '收录新海诚、细田守等名导剧场版作品，高清画质，沉浸式观影体验。',
    meta: '高清 1080P+',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20group%20of%20friends%20watching%20fireworks%20under%20cherry%20blossom%20trees%20at%20night%2C%20colorful%20fireworks%20reflecting%20on%20water%2C%20warm%20and%20magical%20atmosphere%2C%20beautiful%20anime%20art%2C%20soft%20glowing%20lights%2C%20romantic%20scene%2C%20high%20detail&width=800&height=600&seq=91sakura-card-04&orientation=landscape',
    title: '国创动漫专区',
    tag: '国创精选',
    desc: '支持国产动画，收录雾山五行、时光代理人等国创佳作，画风剧情双在线。',
    meta: '持续更新中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20illustration%20of%20a%20mystical%20forest%20with%20cherry%20blossom%20petals%20floating%20through%20sunbeams%2C%20magical%20atmosphere%2C%20soft%20ethereal%20lighting%2C%20sparkling%20particles%2C%20dreamy%20pastel%20color%20palette%2C%20fantasy%20anime%20style%2C%20beautiful%20composition%2C%20high%20quality%20illustration&width=800&height=600&seq=91sakura-card-05&orientation=landscape',
    title: '冷门佳作挖掘',
    tag: '宝藏推荐',
    desc: '那些评分高却少有人知的冷门神作，我们的编辑团队为你一一筛选推荐。',
    meta: '编辑精选',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">91樱花编辑团队为你精心挑选的动漫内容专题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((item, idx) => (
            <article key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{item.meta}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}